import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.forceHeaderStyling()
  }

  forceHeaderStyling() {
    const header = this.element

    // Force job title size - target job_turbo.html.erb structure
    const jobTitle = header.querySelector('.job-title-details')
    if (jobTitle) {
      jobTitle.style.setProperty('font-size', '18px', 'important')
      jobTitle.style.setProperty('font-weight', '700', 'important')
      jobTitle.style.setProperty('color', 'white', 'important')
      jobTitle.style.setProperty('line-height', '1.1', 'important')
      jobTitle.style.setProperty('font-family', "'Inter', sans-serif", 'important')
    }

    // Force company name size - target job_turbo.html.erb structure
    const companyName = header.querySelector('.company-link-details')
    if (companyName) {
      companyName.style.setProperty('font-size', '12px', 'important')
      companyName.style.setProperty('color', '#9CA3AF', 'important')
      companyName.style.setProperty('font-family', "'Inter', sans-serif", 'important')
      companyName.style.setProperty('line-height', '1.1', 'important')
    }

    // Force heart icon positioning and color - target job_turbo.html.erb structure
    const heartIconContainer = header.querySelector('.job-meta-item.favorite-item')
    const heartIcon = header.querySelector('.job-meta-item.favorite-item .myicon')
    
    if (heartIconContainer) {
      heartIconContainer.style.setProperty('position', 'absolute', 'important')
      heartIconContainer.style.setProperty('bottom', '12px', 'important')
      heartIconContainer.style.setProperty('right', '16px', 'important')
      heartIconContainer.style.setProperty('top', 'auto', 'important')
      heartIconContainer.style.setProperty('z-index', '10', 'important')
    }
    
    if (heartIcon) {
      heartIcon.style.setProperty('background', '#191A23', 'important')
      heartIcon.style.setProperty('background-color', '#191A23', 'important')
    }

    // Force apply button positioning - center vertically in right area
    const applySection = header.querySelector('.apply-actions-section')
    if (applySection) {
      applySection.style.setProperty('position', 'absolute', 'important')
      applySection.style.setProperty('top', '50%', 'important')
      applySection.style.setProperty('right', '80px', 'important')
      applySection.style.setProperty('transform', 'translateY(-50%)', 'important')
      applySection.style.setProperty('left', 'auto', 'important')
      applySection.style.setProperty('bottom', 'auto', 'important')
      applySection.style.setProperty('z-index', '20', 'important')
    }

    // Use static positioning for proper alignment in two-column layout
    header.style.setProperty('position', 'static', 'important')
  }
}
